import { Box, BoxProps, Button, Text } from '@air/zephyr';
import Image from 'next/image';
import Link from 'next/link';

import { AuthRoutes } from '~/old-marketing/constants/Routes';

export interface AgencyUpsellProps extends Pick<BoxProps, 'tx'> {}

export const AgencyUpsell = ({ tx }: AgencyUpsellProps) => {
  return (
    <Box
      tx={{
        zIndex: 1,
        position: 'relative',
        backgroundColor: 'peacock400',
        px: 24,
        py: 32,
        textAlign: 'center',
        borderRadius: 4,
        ...tx,
      }}
    >
      <Box tx={{ zIndex: -1, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden' }}>
        <Image alt="Swirls" height={441} src="/assets/marketing/agency-upsell-swirls.svg" width={694} />
      </Box>
      <Text tx={{ maxWidth: 382, mx: 'auto', mb: 24, color: 'jay700' }} variant="text-heading-32">
        Manage client projects with ease
      </Text>
      <Link href={AuthRoutes.signUp} passHref>
        <Button as="a" variant="button-filled-blue">
          Try Air for free
        </Button>
      </Link>
    </Box>
  );
};
